import Grid from "@material-ui/core/Grid";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Checkbox } from "@material-ui/core";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { hideProfileDriverAddressModal, profileDriverAddNewAddress, } from "../../../store/profile/action";
import '../../Pages/page.css';
import { getProfileData, getStatesSelector, } from "../../../store/profile/selector";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(1),
  },
  additionalDetails: {
    textAlign: "left",
    fontSize: "20px",
    fontWeight: "bold",
  },
  txtLeft: {
    textAlign: "left",
    width: "100%",
  },
  textInput: {
    width: "100%",
  },
  selectBox: {
    width: "100%",
    height: 50,
  },
  btnSave: {
    paddingLeft: 50,
    paddingRight: 50,
    backgroundColor: "#20419a",
    color: "white",
  },
  btnRow: {
    textAlign: "right",
    marginTop: 20,
  },
}));

const AddAddressModalForm = (props) => {
  const { handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const profileStore = useSelector(getProfileData);
  const cityStates = useSelector(getStatesSelector);

  const formik = useFormik({
    initialValues: {
      accountId: profileStore?.endUserAccountEntity?.id,
      defaultFlag: true,
      line1: "",
      line2: "",
      city: "",
      state: {
        code: "",
      },
      zip: "",
    },
    onSubmit: (values) => {
      dispatch(profileDriverAddNewAddress({ values, profileStore }));
      dispatch(hideProfileDriverAddressModal());
    },
  });

  const handleSelect = (e) => {
    formik.setFieldValue("state", { code: e.target.value });
  };

  const handleCheckbox = (e) => {
    formik.setFieldValue("defaultFlag", e.target.checked);
  };

  return (
    <>
      <form onSubmit={formik.handleSubmit} className="dAdd">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <InputLabel htmlFor="outlined-make" className={classes.vin}>
              Address *
            </InputLabel>
            <TextField
              level="Address *"
              type={"text"}
              id="line1"
              name="line1"
              onChange={formik.handleChange}
              value={formik && formik.values.line1}
              className={classes.textInput}
              helperText="1234 Generic Lane"
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              level="Address2 *"
              type={"text"}
              value={formik && formik.line2}
              id="line2"
              name="line2"
              onChange={formik.handleChange}
              value={formik.values.line2}
              className={classes.textInput}
              helperText="Apt C Unit#104"
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="outlined-make" className={classes.vin}>
              City *
            </InputLabel>
            <TextField
              level="City *"
              type={"text"}
              name="city"
              onChange={formik.handleChange}
              value={formik && formik.values.city}
              className={classes.textInput}
            />
          </Grid>
          <Grid item xs={12} sm={12} xxl={6} xl={6} lg={6} md={6}>
            <FormControl variant="outlined" style={{ width: "100%" }}>
              <InputLabel htmlFor="outlined-state">Select State</InputLabel>
              <Select
                native
                onChange={handleSelect}
                value={formik.values.state.code || "Choose ..."}
                label="Select State"
                id="code"
                name="code"
                className={classes.selectBox}
                displayEmpty
              >
                <option>Choose ...</option>
                {cityStates &&
                  cityStates.map(function (element) {
                    if (element && element.mexicoState) {
                      return (
                        <option
                          value=""
                          disabled
                          style={{ color: "#00f", fontWeight: "bold" }}
                        >
                          {element.mexicoState}
                        </option>
                      );
                    } else if (element && element.canadaState) {
                      return (
                        <option
                          value=""
                          disabled
                          style={{ color: "#00f", fontWeight: "bold" }}
                        >
                          {element.canadaState}
                        </option>
                      );
                    } else {
                      return (
                        <option value={element.code}>
                          {element.name}
                        </option>
                      );
                    }
                  })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} xxl={6} xl={6} lg={6} md={6}>
            <InputLabel htmlFor="outlined-make" className="vin">
              Zip Code *
            </InputLabel>
            <TextField
              level="Zip Code *"
              type={"text"}
              name="zip"
              id="zip"
              maxlength={10}
              onChange={formik.handleChange}
              value={formik.values.zip}
              className={classes.textInput}
            />
          </Grid>
          <Grid item xs={12}>
            <div className="d-flex align-items-center">
              <Checkbox
                name="defaultFlag"
                checked={formik.values.defaultFlag}
                color="primary"
                id="outlined-make"
                onChange={handleCheckbox}
              />
              <InputLabel htmlFor="outlined-make" className="vin">
                Set The Default Address{" "}
              </InputLabel>

            </div>
          </Grid>

          <Grid item xs={12}>
            <div className='d-flex justify-content-between align-items-center'>
              <Button onClick={handleClose} className="mr-2">Cancel</Button>
              <Button
                variant="contained"
                type="submit"
                className={classes.btnSave}
              >
                Save
              </Button>
            </div>
          </Grid>
        </Grid>

      </form>
    </>
  );
};

export default AddAddressModalForm;
